import React, { useRef, useEffect } from 'react';
import map from 'lodash/map';

import ImageItem from '../ImageItem/ImageItem';
import styles from './ImageTooltip.module.css';

const ELEM_IDS = [
  'view-image',
  'copy-image',
  'delete-image',
  'edit-image',
  'add-image',
];

const ImageTooltip = ({ images, isGallery, closeTooltip }) => {
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      !ELEM_IDS.includes(event.target.id)
    ) {
      closeTooltip();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  return (
    <div
      className={`${styles.container} ${styles.imageTooltip}`}
      ref={containerRef}
    >
      <ul className={styles.itemContainer}>
        {map(images, (image, index) => (
          <ImageItem key={index} image={image} isGallery={isGallery} />
        ))}
      </ul>
    </div>
  );
};

export default ImageTooltip;
